import { TypedUseSelectorHook, useSelector } from 'react-redux';
import {
    UTILISATEUR_SLICE_NAME,
    UTILISATEUR_REDUCER_NAME,
    SERVICES_SLICE_NAME,
    POLES_SLICE_NAME,
    MARQUES_SLICE_NAME,
    GROUPES_SLICE_NAME,
    ANTENNES_SLICE_NAME,
    GROUPE_TRAVAIL_SLICE_NAME,
    UTILISATEUR_GROUPE_TRAVAIL_SLICE_NAME,
    DOMAINES_SLICE_NAME,
} from './constants';
import { UtilisateursStateType } from './types';

// Create selectors.
export const utilisateursSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][UTILISATEUR_SLICE_NAME].main;

export const autoSearchSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][UTILISATEUR_SLICE_NAME].autosearch;

export const groupesTravailSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][GROUPE_TRAVAIL_SLICE_NAME].main;

export const utilisateursGroupesTravailSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][UTILISATEUR_GROUPE_TRAVAIL_SLICE_NAME].main;

export const groupeTravailActiveInscriptionsSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][UTILISATEUR_GROUPE_TRAVAIL_SLICE_NAME]
        .groupeTravailActiveInscriptions;

export const servicesSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][SERVICES_SLICE_NAME].main;

export const polesSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][POLES_SLICE_NAME].main;

export const marquesSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][MARQUES_SLICE_NAME].main;

export const groupesSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][GROUPES_SLICE_NAME].main;

export const antennesSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][ANTENNES_SLICE_NAME].main;

export const domainesSelector = (s: UtilisateursStateType) =>
    s[UTILISATEUR_REDUCER_NAME][DOMAINES_SLICE_NAME].main;

// Create a specific hook.
export const useUtilisateursServiceSelector: TypedUseSelectorHook<UtilisateursStateType> =
    useSelector;
